import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { ProductType } from 'sections/Company/VisionStrategy/types';
import { productsData } from 'sections/Company/VisionStrategy/data';
import styles from 'sections/Company/VisionStrategy/components/SectionProducts/SectionProducts.module.scss';

const cn = classNames.bind(styles);

const SectionProducts = (): ReactElement => {
  const products = productsData.map((product: ProductType, index: number) => {
    return (
      <div className={cn('products__item')} key={product.id}>
        <div className={cn('products__item-number')}>{index + 1}</div>
        <div className={cn('products__item-container')}>
          <div
            className={cn('products__item-description')}
            dangerouslySetInnerHTML={{ __html: product.description(cn) }}
          />
          <div className={cn('products__item-icon')}>
            <img
              src={`/images/pages/Company/VisionAndStrategy/${product.iconName}.svg`}
              alt='icon'
            />
          </div>
        </div>
      </div>
    );
  });

  return (
    <section className={cn('products')}>
      <div className={cn('container')}>

        <h2 className={cn('products__heading')}>
          Looking at the range of products on offer on the DFA
          website our recommended strategy for “plugging in” is as follows:
        </h2>

        <div className={cn('products__items-container')}>
          {products}
        </div>

      </div>
    </section>
  );
};

export default SectionProducts;